// extracted by mini-css-extract-plugin
export default {"NavLink":"NavigationItems_NavLink__QGI5o"};